<template>
  <el-card  @click="adminshow" class="box-card user">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span class="font-sz24">宣传管理</span>
      <div class="head-text">
        <!-- 新建事件 -->
        <el-button type="primary" @click="addDialogFormVisible = true"
          >新建</el-button
        >
        <el-button type="primary" class="mar-left4" @click="batchDeletion"
          >删除</el-button
        >
      </div>
    </div>

    <div class="propaganda-table">
      <!-- 表格 -->
      <el-table
        :data="tableData"
        class="width100"
        :default-sort="{ prop: 'date', order: 'ascending' }"
        @selection-change="handleSelectionChange"
        v-loading="loading"
        height="72vh"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          align="center"
          type="index"
          width="50"
          label="序号"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="publ02"
          label="名称"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="publ03"
          label="点击量"
          sortable
        ></el-table-column>
        <el-table-column
          align="center"
          prop="publ04"
          label="网页链接"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="publ05"
          label="更新时间"
          sortable
        ></el-table-column>
        <el-table-column align="center" label="启用">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.publ08 == 0 ? true : false"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="(val) => changeSwitch2(val, scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="操作" width>
            <template slot-scope="scope">
              <el-button
                type="primary"
                plain
                size="small"
                @click="editorDialogFormVisible(scope.row)"
              >编辑</el-button>
              <el-button
                plain
                type="danger"
                style="margin:0 0 0 4px"
                size="small"
                @click="showDeleteDialog(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column> -->
      </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageDate"
      :page-sizes="[100, 50, 10]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagess"
      align="center"
      class="mar-top20"
    ></el-pagination>

    <!-- 新建 -->
    <el-dialog
      :close-on-click-modal="false"
      title="新建宣传"
      :visible.sync="addDialogFormVisible"
    >
      <el-form :model="addForm" label-width="80px" ref="addForm">
        <el-form-item label="文件" prop="mode09">
          <el-upload
            ref="upload"
            class="upload-demo"
            :action="actionUrl"
            :on-change="handleChange"
            :file-list="fileList"
            :limit="1"
            :data="addForm"
            :before-upload="beforeUpload"
            :auto-upload="false"
            :on-success="uploadSuccess"
            :headers="importHeaders"
            :on-exceed="handleExceed"
            :on-error="uploadError"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传图片(图片提醒：请确上传尺寸为360 x 475的图片)
            </div>
          </el-upload>
        </el-form-item>
        <!-- <el-form-item label="名称" prop="publ02">
            <el-input v-model="addForm.publ02" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="优先级" prop="publ07">
            <el-input v-model="addForm.publ07" auto-complete="off"></el-input>
          </el-form-item> -->
        <el-form-item label="链接" prop="publ04">
          <el-input v-model="addForm.publ04" auto-complete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="时间">
            <el-date-picker
              @change="changeTime1"
              v-model="DateTimeArray"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="启用" prop="publ08">
            <el-switch
              v-model="swithName"
              @change="selectChange"
              active-color="#ff4949"
              inactive-color="#13ce66"
            ></el-switch>
          </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="mar-r10"
          @click="addUserSubmit('addForm')"
          v-if="btnShow"
          >确定</el-button
        >
        <el-button
          type="danger"
          class="mar-r10"
          @click="addDialogFormVisible = false"
          v-if="btnShow"
          >取消</el-button
        >
      </div>
    </el-dialog>

    <!-- 编辑用户 -->
    <el-dialog
      :close-on-click-modal="false"
      title="编辑宣传信息"
      :visible.sync="editorDialogFormVisible1"
      width="50%"
      height="50%"
    >
      <el-form :model="editForm" label-width="80px" ref="editForm">
        <el-form-item label="文件" prop="mode09">
          <el-upload
            ref="upload2"
            class="upload-demo"
            :action="actionUrl2"
            :on-change="handleChange2"
            :file-list="fileList2"
            :limit="1"
            :data="editForm"
            :before-upload="beforeUpload2"
            :auto-upload="false"
            :on-success="uploadSuccess2"
            :headers="importHeaders"
            :on-exceed="handleExceed"
            :on-error="uploadError"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传图片(图片提醒：请确上传尺寸为360 x 475的图片)
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="名称" prop="publ02">
          <el-input v-model="editForm.publ02" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="优先级" prop="publ07">
          <el-input v-model="editForm.publ07" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="链接" prop="publ04">
          <el-input v-model="editForm.publ04" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="时间" prop="DateTimeArray">
          <el-date-picker
            @change="changeTime2"
            v-model="DateTimeArray2"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="mar-r10"
          @click="editUserSubmit('editForm')"
          v-if="btnShow"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </el-card>
</template>
<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
import {
  Getpublicity,
  Addpublicity,
  Compilepublicity,
  Removepublicity,
  Findpublicity,
  EditPublicity,
  EnablePublicity,
} from "@/setAxios.js";
export default {
  name: "announcement",
  props: ["showAdmin"],
  data() {
    return {
      addForm: {
        // publ02: "",
        publ04: "",
        // publ07: "",
        publ08: 0,
        // publ09: "",
        // publ10: "",
      },
      editForm: {},
      swithName: false,
      fileList: [],
      fileList2: [],
      actionUrl: this.$store.state.baseUrl + "/api/AddPublicity",
      actionUrl2: this.$store.state.baseUrl + "/api/EditPublicity",
      importHeaders: { token: localStorage.getItem("token") },
      loading2: false,
      pagess: 10,
      pageDate: 1,
      value2: false,
      loading: true,
      tableData: [],
      total: 0,
      pagesize: 10,
      pagenum: 1,
      btnShow: true,
      addDialogFormVisible: false,
      editorDialogFormVisible1: false,
      seeDialogFormVisible1: false,
      multipleSelection: [],
      DateTimeArray: [],
      DateTimeArray2: [],
      i: 0,
    };
  },
  //   模型初始化时调用方法请求接口
  created() {
    this.getData();
  },
  methods: {
    // 启用禁用
    changeSwitch2(val, row) {
      // debugger;
      let params = {
        id: row.publ01,
        type: val == true ? 0 : 1,
      };
      EnablePublicity({ ...params }).then((res) => {
        if (res.Code > 0) {
          if (val == true) {
            this.$message({
              type: "success",
              message: "启用成功",
            });
          } else {
            this.$message({
              type: "success",
              message: "禁用成功",
            });
          }
          this.getData();
        }
      });
    },
    selectChange(val) {
      //(val);
      if (val == false) {
        this.addForm.publ08 = 0;
        //(this.addForm);
      } else {
        this.addForm.publ08 = 1;
      }
    },
    changeTime1(val) {
      this.addForm.publ09 = val[0];
      this.addForm.publ10 = val[1];
    },
    changeTime2(val) {
      this.editForm.publ09 = val[0];
      this.editForm.publ10 = val[1];
    },
    beforeUpload(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("model", this.addForm);
    },
    beforeUpload2(file) {
      //(file, "文件");
      let fd = new FormData();
      fd.append("file", file);
      fd.append("model", this.editForm);
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    handleChange2(file, fileList) {
      this.fileList2 = fileList.slice(-3);
    },
    // 上传成功
    uploadSuccess(data) {
      this.loading2 = false;
      this.addDialogFormVisible = false;
      if (data.Code > 0) {
        this.$message({
          message: "添加成功",
          type: "success",
        });
      }
      this.getData();
    },
    uploadSuccess2(data) {
      this.loading2 = false;
      this.editorDialogFormVisible1 = false;
      if (data.Code > 0) {
        this.$message({
          message: "添加成功",
          type: "success",
        });
      }
      this.getData();
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    uploadError() {
      this.loading2 = false;
    },
    // 导出表格所用
    exportExcel() {
      // 设置当前日期
      let time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      let name = year + "" + month + "" + day;
      // //(name)
      /* generate workbook object from table */
      //  .table要导出的是哪一个表格
      var wb = XLSX.utils.table_to_book(document.querySelector(".table"));
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        //  name+'.xlsx'表示导出的excel表格名字
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          name + ".xlsx"
        );
      } catch (e) {
        // if (typeof console !== "undefined") //(e, wbout);
      }
      return wbout;
    },
    addcount() {
      GetDeptList().then((res) => {
        this.deptList = res.data;
      });
    },
    // 批量删除
    batchDeletion() {
      if (this.multipleSelection.length > 0) {
        this.$confirm("此操作将永久删除所选择宣传, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            var Selection = [];
            this.multipleSelection.forEach((item, index) => {
              Selection.push(item.publ01);
            });
            //(Selection);

            Removepublicity({ ids: Selection.toString() }).then((res) => {
              if (res.Code > 0) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
                this.getData();
              } else {
                this.$message({
                  message: "删除失败",
                  type: "warning",
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              message: "取消操作",
            });
          });
      } else {
        this.$message({
          message: "没有选择",
          type: "warning",
        });
      }
    },
    // 编辑
    editUserSubmit(formName) {
      if (this.fileList2.length == 0) {
        let params = this.editForm;
        EditPublicity({ ...params }).then((res) => {
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: "修改成功",
            });
            this.editorDialogFormVisible1 = false;
            this.getData();
          }
        });
      } else {
        this.$refs.upload2.submit();
      }
    },
    // 这里是查看
    seeDialogFormVisible() {
      this.seeDialogFormVisible1 = true;
    },
    // 这里是新建
    addUserSubmit(formName) {
      this.$refs.upload.submit();
      this.loading2 = true;
    },
    // 这里是关联管理
    associatedDialogFormVisible(row) {
      this.associatedDialogFormVisible1 = true;
    },
    // 这里是取消关联
    associatedDialogFormVisible2(row) {},
    // 删除用户
    showDeleteDialog(row) {
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        Removepublicity({ ids: JSON.stringify(row.publ01) }).then((res) => {
          //(res);
          if (res.Code > 0) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getData();
          } else {
            this.$message({
              message: "删除失败",
              type: "warning",
            });
          }
        });
      });
    },
    // 这里获取所有数据
    getData() {
      this.loading = true;
      let params = {
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
      };
      Getpublicity({ params })
        .then((res) => {
          //(res);
          this.tableData = res.Data.list;
          this.pagess = res.Data.total;
          setTimeout(() => {
            this.loading = false;
          }, 600);
        })
        .catch((err) => {
          //(err);
        });
    },
    //显示编辑用户对话框
    editorDialogFormVisible(row) {
      let params = {
        id: row.publ01,
      };
      Findpublicity({ params }).then((res) => {
        //(res);
        this.editForm = res.Data;
        this.editForm.publ09 = res.Data.StartTime;
        this.editForm.publ10 = res.Data.OverTime;
        this.DateTimeArray2 = [
          new Date(res.Data.StartTime),
          new Date(res.Data.OverTime),
        ];
      });
      this.editorDialogFormVisible1 = true;
    },
    stopDialogFormVisible(row) {
      ProhibitAccount({ id: row.user01, state: row.user09 == 0 ? 1 : 0 }).then(
        (res) => {
          this.getData();
        }
      );
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      //   //(`每页 ${val} 条`)
      this.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      //   //(`当前页: ${val}`)
      // //("当前页码"+this.pagesize)
      this.pagenum = val;
      this.getData();
    },
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
    },
    handleCurrentChange2(val) {
      this.currentRow = val;
    },
    replaceSub() {
      this.seeDialogFormVisible2 = true;
    },
    // 关闭菜单栏显示
    adminshow() {
      this.$emit("update:showAdmin", true);
    },
  },
};
</script>
<style lang="less" scoped>
.user .search-input {
  width: 300px;
}
table.el-table__header {
  line-height: 60px;
}

.el-button {
  margin: 0;
}
// 新增
.font-sz24 {
  font-size: 24px;
}
.head-text {
  float: right;
  margin-top: -4px;
}
.mar-left4 {
  margin-left: 4px;
}
.width100 {
  width: 100%;
}
.mar-top20 {
  margin-top: 20px;
}
.mar-r10 {
  margin-right: 10px;
}
</style>
